export default function getRolesReducer
    (state = {error: '', success: '', processing: false}, action) {
    switch (action.type) {
        case 'GET_ROLES_SUCCESS':
            return {...state, ...{success: action.success}};

        case 'GET_ROLES_ERROR':
            return {...state, ...{error: action.error}};

        case 'GET_ROLES_PROCESSING':
            return {...state, ...{processing: action.processing}};

        default:
            return state;
    }
}